module.exports = __webpack_public_path__ + "img/activities.4fe77b56.svg";